"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Button = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireWildcard(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _forms = require("@morpheus-ui/forms");

var _transitionClass = _interopRequireDefault(require("../transitionClass"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      letter-spacing: ", ";\n      text-align: ", ";\n      padding: ", ";\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n      ", "\n\n      ", "\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 1;\n  width: 100%;\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      padding: ", ";\n      display: flex;\n      background-color: ", ";\n      align-items: center;\n      justify-content: center;\n      color: ", ";\n      ", "\n      ", "\n      ", "\n      ", "\n\n       ", "\n       ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    min-width: ", ";\n    overflow: hidden;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    background-color: ", ";\n    border-color: ", ";\n    border-width: ", ";\n    border-radius: ", ";\n    ", "\n   ", "\n\n  ", "\n\n\n    ", "\n\n\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-width: ", ";\n  margin: ", ";\n  align-items: center;\n  flex-direction: row;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _native.default.View(_templateObject(), function (_ref) {
  var muitheme = _ref.muitheme;
  return muitheme.minWidth;
}, function (_ref2) {
  var muitheme = _ref2.muitheme;
  return muitheme.margin;
});

var Clicker = _native.default.TouchableWithoutFeedback(_templateObject2());

var InnerContainer = _native.default.View(_templateObject3(), function (_ref3) {
  var muitheme = _ref3.muitheme;
  return muitheme.minWidth;
}, function (_ref4) {
  var muitheme = _ref4.muitheme;
  return muitheme.backgroundColor;
}, function (_ref5) {
  var muitheme = _ref5.muitheme;
  return muitheme.borderColor;
}, function (_ref6) {
  var muitheme = _ref6.muitheme;
  return muitheme.borderWidth;
}, function (_ref7) {
  var muitheme = _ref7.muitheme;
  return muitheme.borderRadius;
}, function (_ref8) {
  var muitheme = _ref8.muitheme;
  return (muitheme.iconPosition === 'top' || muitheme.iconPosition === 'bottom') && "flex-direction: column;";
}, function (_ref9) {
  var muitheme = _ref9.muitheme;
  return muitheme.shadow && " shadow-color: #000;\n       shadow-offset: {width: 0, height: 0};\n       shadow-opacity: 0.1;\n       shadow-radius: 8;\n    ";
}, function (_ref10) {
  var ishover = _ref10.ishover,
      muitheme = _ref10.muitheme,
      disabled = _ref10.disabled;
  return ishover.on && !disabled && " background-color: " + muitheme.backgroundHoverColor + ";\n      border-color: " + muitheme.borderHoverColor + ";\n      " + (muitheme.hoverShadow && " shadow-color: #000;\n          shadow-offset: {width: 0, height: 0};\n          shadow-opacity: 0.1;\n          shadow-radius: 8;\n        ") + "\n     ";
}, function (_ref11) {
  var muitheme = _ref11.muitheme,
      disabled = _ref11.disabled;
  return disabled && " background-color: " + muitheme.backgroundDisabledColor + ";\n      border-color: " + muitheme.borderDisabledColor + ";\n      cursor: not-allowed;\n     ";
});

var IconContainer = _native.default.Text(_templateObject4(), function (_ref12) {
  var muitheme = _ref12.muitheme,
      title = _ref12.title,
      ishover = _ref12.ishover,
      disabled = _ref12.disabled;
  return (0, _native.css)(_templateObject5(), muitheme.iconPadding, muitheme.iconBackgroundColor, muitheme.iconColor, !!title && muitheme.iconPosition === 'top' && "margin-bottom: " + muitheme.iconMargin + "; width: 100%;", !!title && muitheme.iconPosition === 'right' && "margin-left: " + muitheme.iconMargin + "; ", !!title && muitheme.iconPosition === 'bottom' && "margin-top: " + muitheme.iconMargin + "; width: 100%;", !!title && muitheme.iconPosition === 'left' && "margin-right: " + muitheme.iconMargin + ";", ishover.on && "color: " + muitheme.iconHoverColor + ";\n          background-color: " + muitheme.iconHoverBackgroundColor + ";\n", disabled && "\n        color: " + muitheme.iconDisabledColor + ";\n        background-color: " + muitheme.iconDisabledBackgroundColor + ";\n        ");
});

var Title = _native.default.Text(_templateObject6(), function (_ref13) {
  var muitheme = _ref13.muitheme,
      ishover = _ref13.ishover,
      disabled = _ref13.disabled;
  return (0, _native.css)(_templateObject7(), muitheme.letterSpacing, muitheme.titleAlign, muitheme.titlePadding, muitheme.fontFamily, muitheme.fontSize, muitheme.fontWeight, muitheme.titleColor, ishover.on && "color: " + muitheme.titleHoverColor + ";", disabled && "color: " + muitheme.titleDisabledColor + "; cursor: not-allowed;");
});

var Button =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Button, _Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      ishover: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseOver", function () {
      _this.setState({
        ishover: true
      });

      _this.props.onMouseOver && _this.props.onMouseOver();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseLeave", function () {
      _this.setState({
        ishover: false
      });

      _this.props.onMouseLeave && _this.props.onMouseLeave();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSubmit", function () {
      var _this$props = _this.props,
          submit = _this$props.submit,
          onPress = _this$props.onPress,
          disabled = _this$props.disabled,
          invalidFormDisabled = _this$props.invalidFormDisabled,
          formValid = _this$props.formValid,
          submitForm = _this$props.submitForm,
          inForm = _this$props.inForm;
      var isDisabled = disabled || invalidFormDisabled && !formValid;

      if (!isDisabled) {
        if (inForm && submit) {
          submitForm();
        }

        onPress && onPress();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getButtonTheme", (0, _memoizeOne.default)(function (props, context) {
      return (0, _ThemeProvider.getTheme)('Button', props, context);
    }));
    return _this;
  }

  var _proto = Button.prototype;

  _proto.renderIcon = function renderIcon(muitheme) {
    var _this$props2 = this.props,
        Icon = _this$props2.Icon,
        HoverIcon = _this$props2.HoverIcon,
        disabled = _this$props2.disabled,
        invalidFormDisabled = _this$props2.invalidFormDisabled,
        formValid = _this$props2.formValid;
    var isDisabled = disabled || invalidFormDisabled && !formValid;
    if (!Icon) return null;
    var TheIcon = this.state.ishover && !disabled ? HoverIcon || Icon : Icon;
    return _react.default.createElement(IconContainer, {
      className: _transitionClass.default,
      muitheme: muitheme,
      title: this.props.title,
      ishover: {
        on: this.state.ishover
      },
      disabled: isDisabled
    }, _react.default.createElement(TheIcon, {
      width: muitheme.iconWidth,
      height: muitheme.iconHeight
    }));
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        title = _this$props3.title,
        disabled = _this$props3.disabled,
        invalidFormDisabled = _this$props3.invalidFormDisabled,
        formValid = _this$props3.formValid;
    var muitheme = this.getButtonTheme(this.props, this.context);
    var isDisabled = disabled || invalidFormDisabled && !formValid;
    return _react.default.createElement(Container, {
      muitheme: muitheme
    }, _react.default.createElement(Clicker, {
      disabled: isDisabled,
      onMouseOver: this.onMouseOver,
      onMouseLeave: this.onMouseLeave,
      onPress: this.onSubmit
    }, _react.default.createElement(InnerContainer, (0, _extends2.default)({}, this.props, {
      className: _transitionClass.default,
      muitheme: muitheme,
      disabled: isDisabled,
      ishover: {
        on: this.state.ishover
      }
    }), (muitheme.iconPosition === 'left' || muitheme.iconPosition === 'top') && this.renderIcon(muitheme), title ? _react.default.createElement(Title, {
      className: _transitionClass.default,
      ishover: {
        on: this.state.ishover
      },
      muitheme: muitheme,
      disabled: isDisabled
    }, title) : null, (muitheme.iconPosition === 'right' || muitheme.iconPosition === 'bottom') && this.renderIcon(muitheme))));
  };

  return Button;
}(_react.Component);

exports.Button = Button;
(0, _defineProperty2.default)(Button, "contextType", _ThemeProvider.default);

var _default = (0, _forms.turnIntoField)(Button);

exports.default = _default;